import React, { useEffect } from "react";
import { project2_banner } from "../Assets";
import { FiLink } from "react-icons/fi";
import AOS from "aos";
import { Link } from "react-router-dom";

const ProjectRightCard = ({ bannerimg, index, bgColor, liveLink, name }) => {

  useEffect(() => {
    AOS.init({
      duration: 500, // Animation duration in milliseconds
      easing: 'ease-in-out', // Easing function for the animation
    });
  }, []);

  return (
    <>
      <div className="project-right-main-content-box" data-aos="fade-left" data-aos-delay="700" >
        <div className="project-count-box-right" data-aos="fade-up" data-aos-delay="700"> 0{index + 1}</div>
        <div style={{ backgroundColor: bgColor }} className="project-showcase-right-img-box project-showcase-card-box custom-mt" data-aos="fade-left" data-aos-delay="600">
          <img src={bannerimg} alt="banner-2"></img>
          <div className="projects-link-box-cover">
            <div className="projects-link-box">
              <button className="project-link-btn">
                <Link to={liveLink} target="__blank">
                  Live Link{" "}
                  <span>
                    <FiLink />
                  </span>
                </Link>
              </button>
            </div>
          </div>
          <div className="project-details-right-btn-box">
            <div className="project-btn-icon"></div>
            <button>
              <Link to={`/project${index}-details`}>{name}</Link>
            </button>
          </div>
        </div>

      </div>
    </>
  );
};

export default ProjectRightCard;
